// JPEG 出力時の長辺上限。数 MB の upload は院内 NW で遅く、Gemini multimodal も高解像度を
// 要求しない。1600px / quality 0.85 で氏名・生年月日等の細部は十分残る。
// (nasu-patient-app-front CameraCaptureModal の toResizedJpegBlob を流用)
const MAX_LONG_EDGE = 1600
const JPEG_QUALITY = 0.85

// canvas に描画した上で長辺 MAX_LONG_EDGE 以下に縮小し JPEG Blob を返す。
// カメラ (video) 経路でも file 選択 (image) 経路でも同じ縮小を通して一貫させる。
export async function toResizedJpegBlob(
  source: HTMLVideoElement | HTMLImageElement
): Promise<Blob> {
  const naturalW =
    'videoWidth' in source ? source.videoWidth : source.naturalWidth
  const naturalH =
    'videoHeight' in source ? source.videoHeight : source.naturalHeight
  if (naturalW === 0 || naturalH === 0) {
    throw new Error('画像サイズが取得できません')
  }
  const longEdge = Math.max(naturalW, naturalH)
  const scale = longEdge > MAX_LONG_EDGE ? MAX_LONG_EDGE / longEdge : 1
  const w = Math.round(naturalW * scale)
  const h = Math.round(naturalH * scale)
  const canvas = document.createElement('canvas')
  canvas.width = w
  canvas.height = h
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('canvas context 取得失敗')
  ctx.drawImage(source, 0, 0, w, h)
  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) =>
        blob ? resolve(blob) : reject(new Error('canvas.toBlob 失敗')),
      'image/jpeg',
      JPEG_QUALITY
    )
  })
}
